import NewsFeed from "./NewsFeed";
const News = ({ navigateTo }) => {
  return (
    <div className="home-container home-resp-wrap justify-center">
      <NewsFeed navigateTo={navigateTo} />
    </div>
  );
};

export default News;
